import { Http } from '@angular/http';
import { JWTUtil } from '../_utils/jwt.util';
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { APPCONFIG } from '../config';
import { Notice } from '../_models/notice';
import 'rxjs/add/operator/map';
import { EasyMarineHttpClient } from '../_utils/easy-marine-http-client';
import { Cfop, CfopDTO } from '../_models/cfop';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ProductService {

    constructor(
        private http: EasyMarineHttpClient,
        private jwtUtil: JWTUtil
    ) { }

    getCfops(marinaId): Observable<Cfop[]> {
        let headers = new HttpHeaders();
        headers = headers.set('MarinaId', marinaId);

        return this.http.get(`${APPCONFIG.apiHost}/secure/products/cfop`, null, marinaId)
            .map((response: any) => response.data.cfops as Cfop[]);
    }

    saveCfop(cfop: CfopDTO): Observable<Cfop> {
        return this.http.post(`${APPCONFIG.apiHost}/secure/products/cfop`, cfop)
            .map((response: any) => response.data.cfop as Cfop);
    }

    deleteCfop(cfopId): Observable<any> {
        return this.http.delete(`${APPCONFIG.apiHost}/secure/products/cfop/${cfopId}`)
            .map((response: any) => response.data.cfops as Cfop[]);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_services/product.service.ts